import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AdminEditProvider } from "@/contexts/AdminEditContext";
import { CMSDataProvider } from "@/contexts/CMSDataContext";
import { useState, useEffect } from "react";
import LoaderScreen from "./components/LoaderScreen";
import { shouldShowLoader, markLoaderShown } from "@/lib/loaderStorage";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import FreelanceDeveloper from "./pages/jobs/FreelanceDeveloper";
import FreelanceAITechnician from "./pages/jobs/FreelanceAITechnician";
import FreelanceSalesPerson from "./pages/jobs/FreelanceSalesPerson";
import AISolutions from "./pages/services/AISolutions";
import WebSEO from "./pages/services/WebSEO";
import ITConsulting from "./pages/services/ITConsulting";
import SoftwareDevelopment from "./pages/services/SoftwareDevelopment";
import AutomateWorkflows from "./pages/services/AutomateWorkflows";
import ScrollToTop from "@/components/ScrollToTop";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const queryClient = new QueryClient();

const App = () => {
  const [showLoader, setShowLoader] = useState(() => shouldShowLoader());

  useEffect(() => {
    if (showLoader) {
      markLoaderShown();
    }
  }, [showLoader]);

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <CMSDataProvider>
          <AdminEditProvider>
            <TooltipProvider>
            <Toaster />
            <Sonner />
            {showLoader && <LoaderScreen onComplete={() => setShowLoader(false)} />}
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/jobs/freelance-developer" element={<FreelanceDeveloper />} />
              <Route path="/jobs/freelance-ai-technician" element={<FreelanceAITechnician />} />
              <Route path="/jobs/freelance-sales-person" element={<FreelanceSalesPerson />} />
              <Route path="/services/ai-solutions" element={<AISolutions />} />
              <Route path="/services/web-seo" element={<WebSEO />} />
              <Route path="/services/it-consulting" element={<ITConsulting />} />
              <Route path="/services/software-development" element={<SoftwareDevelopment />} />
              <Route path="/services/automate-workflows" element={<AutomateWorkflows />} />

              <Route path="/portal-commodit-7842/login" element={<AdminLogin />} />
              <Route path="/portal-commodit-7842" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
              </Route>

              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
              </TooltipProvider>
            </AdminEditProvider>
          </CMSDataProvider>
        </LanguageProvider>
      </QueryClientProvider>
    );
};

export default App;